import type React from 'react';

import { useLocation } from 'react-router';
import type { BrainAtlasType, MultiLang } from '../config';
import Functions from '../functions';
import ItemUtil, { type SearchCallbackFunc, type SortCondition } from './lib/ItemUtil';
import XoonipsListItem from './lib/XoonipsListItem';

interface Props {
    lang: MultiLang;
    type: BrainAtlasType;
}

const XoonipsSearchByKeyword: React.FC<Props> = (props) => {
    const { lang, type } = props;

    const location = useLocation();
    const query = ItemUtil.getSearchKeywordByQuery(location.search);

    const searchFunc = (condition: SortCondition, func: SearchCallbackFunc) => {
        if (query.keyword === '') {
            const res = { total: 0, data: [] };
            func(res);
        } else {
            ItemUtil.getListByKeyword(type, query.type, query.keyword, condition, func);
        }
    };

    const baseUrl = ItemUtil.getSearchByKeywordUrl(type, query.type, query.keyword);
    return (
        <div className="list">
            <h3>{Functions.mlang('[en]Listing item[/en][ja]アイテム一覧[/ja]', lang)}</h3>
            <p>
                {Functions.mlang('[en]Search Keyword[/en][ja]検索キーワード[/ja]', lang)} : {query.keyword}
            </p>
            <XoonipsListItem lang={lang} url={baseUrl} search={searchFunc} type={type} />
        </div>
    );
};

export default XoonipsSearchByKeyword;
